// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import Admin__ActionController from "./admin/action_controller"
application.register("admin--action", Admin__ActionController)

import Admin__BulkUploadController from "./admin/bulk_upload_controller"
application.register("admin--bulk-upload", Admin__BulkUploadController)

import Admin__ContentStatusController from "./admin/content_status_controller"
application.register("admin--content-status", Admin__ContentStatusController)

import Admin__FileAttachmentController from "./admin/file_attachment_controller"
application.register("admin--file-attachment", Admin__FileAttachmentController)

import Admin__ImageAttachmentController from "./admin/image_attachment_controller"
application.register("admin--image-attachment", Admin__ImageAttachmentController)

import Admin__MultiSelectController from "./admin/multi_select_controller"
application.register("admin--multi-select", Admin__MultiSelectController)

import Admin__SortableController from "./admin/sortable_controller"
application.register("admin--sortable", Admin__SortableController)

import Admin__WorkFilterController from "./admin/work_filter_controller"
application.register("admin--work-filter", Admin__WorkFilterController)

import BiographyController from "./biography_controller"
application.register("biography", BiographyController)

import BreadcrumbsController from "./breadcrumbs_controller"
application.register("breadcrumbs", BreadcrumbsController)

import FeaturedContentController from "./featured_content_controller"
application.register("featured-content", FeaturedContentController)

import GalleryController from "./gallery_controller"
application.register("gallery", GalleryController)

import HeaderController from "./header_controller"
application.register("header", HeaderController)

import HomeController from "./home_controller"
application.register("home", HomeController)

import LightboxController from "./lightbox_controller"
application.register("lightbox", LightboxController)

import MasonryController from "./masonry_controller"
application.register("masonry", MasonryController)

import RelatedContentController from "./related_content_controller"
application.register("related-content", RelatedContentController)
